// extracted by mini-css-extract-plugin
export default {"root":"Footer_root__H-tkn","inner":"Footer_inner__CVEiR","copyright":"Footer_copyright__JQMtz","footnote":"Footer_footnote__+pyJG","socials":"Footer_socials__7h4n1"};